import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { useBag } from '@entities/warehouse/store';
import { FillBag } from '@features/fill-bag';
import { formatBagId } from '@lib/bag-formatting';
import { IBag } from '@@/bags/ts';

import styles from './styles.module.css';

export function EmptyBag(props: IEmptyBagProps) {
  const { className, id, bag, type, editPanel, ...rest } = props;
  const rootClass = cn(className, {
    [styles.bunker]: type === 'bunker',
    [styles.bag]: type === 'sleeve',
  });
  const currentBag = bag ?? useBag(id);

  if (!currentBag) return null;
  const formattedId = formatBagId(currentBag.id);

  if (type === 'bunker') {
    return (
      <div className={rootClass} {...rest}>
        <svg
          width="391"
          height="180"
          viewBox="0 0 304 140"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M302.146 127.455L303.044 127.015L302.147 127.455C304.82 132.901 300.883 139.248 294.811 139.248H152.004H9.18919C3.11725 139.248 -0.820157 132.901 1.85342 127.455L1.85356 127.455C29.0534 72.0065 70.9483 29.1735 112.986 9.98186C137.771 -1.32928 166.237 -1.3292 191.014 9.98186C233.052 29.1735 274.938 72.0064 302.146 127.455Z"
            fill="white"
            stroke="#66B28A"
            strokeWidth="2"
          />
        </svg>

        <div className={styles.content}>
          <FillBag
            buttonClassName={styles.fillBtn}
            buttonContent={
              <>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 1.5V16.5M16.5 9L1.5 9"
                    stroke="#007E3C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div>добавить культуру</div>
              </>
            }
            id={currentBag.id}
            editPanel={editPanel}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={rootClass} {...rest}>
      <div className={styles.id}>{formattedId}</div>
      <FillBag id={currentBag.id} />
      {editPanel}
    </div>
  );
}

export interface IEmptyBagProps extends HTMLAttributes<HTMLDivElement> {
  id: string;
  bag?: IBag;
  type: 'sleeve' | 'bunker';
  editPanel: React.ReactNode;
}
